export * from './IconThermometerChange';
export { default as IconThermometerChange } from './IconThermometerChange';
